import { render, staticRenderFns } from "./Dangan.vue?vue&type=template&id=847fe184&"
import script from "./Dangan.vue?vue&type=script&lang=js&"
export * from "./Dangan.vue?vue&type=script&lang=js&"
import style0 from "./Dangan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports